import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {AppData} from "../AppData";
import {Observable} from "rxjs";
import {UrlBuilder} from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import {ServiceProviderModel} from "../../models/service_provider/service-provider.model";

@Injectable()
export class ServiceProviderRequestService {

  //region CONSTRUCTOR
  constructor (
    private http: HttpClient,
    private data: AppData
  ) {}
  //endregion

  //region GET
  getServiceProviderById(id: string) : Observable<ServiceProviderModel> {
    const url: string = new UrlBuilder(Constants.URLS.serviceProviders.baseUrl + id)
      .build();

    return this.http.get<ServiceProviderModel>(url);
  }
  //endregion

  //region POST
  createServiceProvider(serviceProvider: ServiceProviderModel) : Observable<ServiceProviderModel> {
    const url: string = new UrlBuilder(Constants.URLS.serviceProviders.createServiceProvider)
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.post<ServiceProviderModel>(url, serviceProvider);
  }
  //endregion

  //region PUT
  updateServiceProvider(serviceProvider: ServiceProviderModel) : Observable<ServiceProviderModel> {
    const url: string = new UrlBuilder(Constants.URLS.serviceProviders.updateServiceProvider)
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<ServiceProviderModel>(url, serviceProvider);
  }
  //endregion

  //region DELETE
  deleteServiceProvider(serviceProviderId: string): Observable<void> {
    const url: string =
      new UrlBuilder(Constants.URLS.serviceProviders.deleteServiceProvider
        .replace("%1", serviceProviderId))
        .param('accessMode', this.data.getAccessMode())
        .build();

    return this.http.delete<void>(url);
  }
  //endregion

}
